import Layout from '@/components/feature/Layout';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import HotRecommend from './components/HotRecommend';
import FeatureBanner from './components/FeatureBanner';
import CategoryGrid from './components/CategoryGrid';
import LatestUpdates from './components/LatestUpdates';
import ArticleSection from './components/ArticleSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '91动漫',
  url: 'https://beyondtoon.github.io',
  description: '91动漫是专注动漫爱好者的在线观看平台，汇聚海量国漫、日漫、美漫资源，支持高清免费播放。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://beyondtoon.github.io/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <Layout>
      <SEOHead
        title="91动漫 - 海量动漫资源免费在线观看平台"
        description="91动漫是专注动漫爱好者的在线观看平台，汇聚海量国漫、日漫、美漫资源，支持高清免费播放。无论你喜欢热血冒险、恋爱日常还是奇幻玄幻，91动漫都能满足你的追番需求。"
        keywords="91动漫,91动漫在线观看,91动漫免费播放,91动漫高清资源,动漫在线观看,免费追番平台,热门动漫推荐"
        schema={homeSchema}
      />

      <article>
        <HeroSection />
        <HotRecommend />
        <FeatureBanner />
        <CategoryGrid />
        <LatestUpdates />
        <ArticleSection />
      </article>
    </Layout>
  );
}